import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import WorkerGdsRcptAnalysisReportActions from '../../Stores/WorkerGdsRcptAnalysisReport/Actions';

const { Panel } = Collapse;

class WorkerGdsRcptAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initWorkerGdsRcptAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initWorkerGdsRcptAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initWorkerGdsRcptAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initWorkerGdsRcptAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'worker_gds_rcpt_analysis_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

WorkerGdsRcptAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initWorkerGdsRcptAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

WorkerGdsRcptAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initWorkerGdsRcptAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initWorkerGdsRcptAnalysis: () =>
    dispatch(
      WorkerGdsRcptAnalysisReportActions.workerGdsRcptAnalysisReportInitWorkerGdsRcptAnalysis()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WorkerGdsRcptAnalysisReportScreen));
